import * as React from 'react';
import { ValueItem } from 'ui/common/select/types';
import { ComplexValue } from 'ui';
import { Expandable, ShouldTruncate, CreateRenderer } from 'ui/expandable';
import styles from './value-display.scss';

interface ValueDisplay {
  valueItem?: ComplexValue<string> | ComplexValue<number>;
  prefix?: string;
  suffix?: string;
  classNames?: string;
  style?: {[prop:string]: string};
  shouldTruncate?: boolean;
  textDisplayMore?: string;
  textDisplayLess?: string;
}

export const ValueDisplay = (props: ValueDisplay) => {
  const {
    valueItem,
    prefix,
    suffix,
    classNames = '',
    style,
    textDisplayMore,
    textDisplayLess,
    shouldTruncate = false
  } = props;

  if(!valueItem) {
    return null;
  }
  const {description, value} = valueItem;
  const text = [
    description && prefix,
    description,
    !description && value,
    suffix
  ].filter(val => val).join('');

  const doTruncation = shouldTruncate && ShouldTruncate(text);
  const render = CreateRenderer(text);

  return (<span className={`${classNames} value-display`} style={style}>
    {doTruncation ? <p className={styles.truncatedValue}>
      <Expandable content={render} {...{ textDisplayMore, textDisplayLess }} />
    </p> : text}
    {doTruncation ? <p className={`${styles.valuePrintOnly}`}>{text}</p> : null}
  </span>
  );
};

interface MultipleValueDisplay {
  valueItems?: ValueItem[];
  classNames?: string;
}

export const MultipleValueDisplay = ({ valueItems, classNames = '' }: MultipleValueDisplay) => (
  <span className={`${classNames}`}>
    {valueItems && valueItems.map(vi => vi.description).join(', ')}
  </span>);
